import { Component } from '@angular/core';

import { PopupService } from '../../services/popup.service';
import { LogoutConfirmationModalComponent } from '../logout-confirmation-modal/logout-confirmation-modal.component';

@Component({
    selector: 'app-logout-button',
    templateUrl: './logout-button.component.html',
    standalone: false
})

export class LogoutButtonComponent {

    constructor(
        private popupService: PopupService
    ) {}

    confirmLogout() {
        this.popupService.open(LogoutConfirmationModalComponent, {});
    }
}
